import { useState } from "react";
import ReactApexChart from "react-apexcharts";

import type { SalesData, SubscriptionData } from "./types";
import { formatCurrency, formatMonthYear } from "./utils";

type Props = {
	salesData: SalesData[];
	subscriptionsData: SubscriptionData[];
};

export const MonthlyEvolutionChart: React.FC<Props> = ({
	salesData,
	subscriptionsData,
}) => {
	const [activeTab, setActiveTab] = useState<"sales" | "subscriptions">(
		"sales",
	);

	return (
		<div className="bg-white rounded-xl shadow-md p-6 overflow-hidden">
			<div className="flex justify-between items-center mb-6">
				<h2 className="text-lg font-semibold text-gray-700">Evolução Mensal</h2>
				<div className="flex bg-gray-100 rounded-lg p-1">
					<button
						className={`px-3 py-1 text-sm rounded-md transition ${
							activeTab === "sales"
								? "bg-white shadow-sm text-blue-600"
								: "text-gray-600"
						}`}
						onClick={() => setActiveTab("sales")}
					>
						Vendas
					</button>
					<button
						className={`px-3 py-1 text-sm rounded-md transition ${
							activeTab === "subscriptions"
								? "bg-white shadow-sm text-blue-600"
								: "text-gray-600"
						}`}
						onClick={() => setActiveTab("subscriptions")}
					>
						Assinaturas
					</button>
				</div>
			</div>

			<div className="overflow-x-auto">
				<ReactApexChart
					type={activeTab === "sales" ? "bar" : "line"}
					height={350}
					width="100%"
					options={{
						chart: {
							toolbar: {
								show: false,
							},
							zoom: {
								enabled: false,
							},
						},
						xaxis: {
							categories:
								activeTab === "sales"
									? salesData.map((item) => formatMonthYear(item.month))
									: subscriptionsData.map((item) =>
											formatMonthYear(item.month),
										),
							labels: {
								style: {
									colors: "#64748b",
								},
							},
						},
						yaxis: {
							labels: {
								formatter: (value) =>
									activeTab === "sales"
										? formatCurrency(value)
										: value.toFixed(0),
								style: {
									colors: "#64748b",
								},
							},
						},
						colors: activeTab === "sales" ? ["#3b82f6"] : ["#9333ea"],
						dataLabels: {
							enabled: false,
						},
						stroke: {
							curve: "smooth",
							width: activeTab === "sales" ? 0 : 3,
						},
						tooltip: {
							y: {
								formatter: (value) =>
									activeTab === "sales"
										? formatCurrency(value)
										: value + " assinaturas",
							},
						},
						grid: {
							borderColor: "#f1f5f9",
						},
						plotOptions:
							activeTab === "sales"
								? {
										bar: {
											borderRadius: 6,
											columnWidth: "60%",
										},
									}
								: {},
					}}
					series={[
						{
							name: activeTab === "sales" ? "Vendas" : "Novas Assinaturas",
							data:
								activeTab === "sales"
									? salesData.map((item) => item.amount)
									: subscriptionsData.map((item) => item.count),
						},
					]}
				/>
			</div>
		</div>
	);
};
